import React, { Component } from "react";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Dashboard from "./components/Dashboard";
import Imprimir from "./components/Imprimir";

class App extends Component {
    render() {
        return (
            <Router>
                <Routes>
                    {/* Ambas rutas terminan en /* porque los dos componentes
                        declaran sus propias <Routes> descendientes. */}
                    <Route path='/:sucursal/imprimir/*' element={<Imprimir />} />
                    <Route path='/*' element={<Dashboard />} />
                </Routes>
            </Router>
        );
    }
}
export default App;
